// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__27A-B","header":"Messages_header__d95cZ"};